import { render, staticRenderFns } from "./DictStRepFormColGroupListPage.vue?vue&type=template&id=83154aa4&"
import script from "./DictStRepFormColGroupListPage.vue?vue&type=script&lang=ts&"
export * from "./DictStRepFormColGroupListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports